import { Platform } from 'react-native';
import { createStackNavigator } from '@react-navigation/stack';
import Constants from 'src/core/utils/Constants';
import { useAuthStore } from 'src/domain/stores/useAuthStore';
import type { AuthNavigation } from 'src/presentation/navigation/types/NavigationTypes';
import LoginScreen from 'src/presentation/screens/LoginScreen';
import OnboardingScreen from 'src/presentation/screens/OnboardingScreen';

const AuthStack = createStackNavigator<AuthNavigation>();

export default function AuthNavigator() {
	const { didOnboarding } = useAuthStore();

	return (
		<AuthStack.Navigator
			initialRouteName={
				didOnboarding || Platform.OS === Constants.platformWeb ? Constants.screenLogin : Constants.screenOnboarding
			}
			screenOptions={{
				headerShown: false,
				gestureEnabled: false,
			}}
		>
			<AuthStack.Screen component={LoginScreen} name={Constants.screenLogin} />
			{!didOnboarding || Platform.OS === Constants.platformWeb ? (
				<AuthStack.Screen component={OnboardingScreen} name={Constants.screenOnboarding} />
			) : null}
		</AuthStack.Navigator>
	);
}
